import React from 'react';
import styled from 'styled-components';
import { CUSTOM_MESSAGE_TYPE } from './MessageProcessing';

const TimeoutMessage = styled.div`
    display: block;
    margin: auto;
    width: 240px;
    overflow: hidden;
    background: rgba(253, 244, 227, 1);
    border-radius: 8px;
`;
const TimeoutMain = styled.div`
    width: 100%;
    padding: 14px 12px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    text-align: center;
`;
const TimeoutTitle = styled.div`
    margin-bottom: 11px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
`;
const TimeoutActions = styled.div`
    width: 100%;
    height: 34px;
    border-top: 1px solid #f9ead0;

    & > button {
        width: 50%;
        padding: 10px 28px;
        background: transparent;
        border: none;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 14px;
        cursor: pointer;

        &.primary {
            font-weight: 500;
            color: rgba(45, 128, 241, 1);
        }

        &:first-child {
            border-right: 1px solid #f9ead0;
        }
    }
`;

export function createTimeoutMessage(props, messageData) {
    const { primaryAction, secondaryAction } = messageData;
    return (
        <TimeoutMessage>
            <TimeoutMain>
                <TimeoutTitle>{messageData.title}</TimeoutTitle>
                <span>{messageData.showText}</span>
            </TimeoutMain>
            <TimeoutActions>
                <button
                    className="primary"
                    onClick={() => {
                        const action = props[primaryAction.actionName];
                        if (typeof action === 'function') {
                            action.apply(undefined, primaryAction.arguments);
                        }
                    }}
                >
                    {primaryAction.name}
                </button>
                <button
                    onClick={() => {
                        const action = props[secondaryAction.actionName];
                        if (typeof action === 'function') {
                            action.apply(undefined, secondaryAction.arguments);
                        }
                    }}
                >
                    {secondaryAction.name}
                </button>
            </TimeoutActions>
        </TimeoutMessage>
    );
}

export function sendTimeoutMessage(toAccount, toNickname) {
    return {
        type: 'custom',
        scene: 'p2p',
        toNick: toNickname,
        to: toAccount,
        sessionId: `p2p-${toAccount}`,
        text: 'obj.text',
        time: Date.now(),
        content: JSON.stringify({
            customType: CUSTOM_MESSAGE_TYPE.TIMEOUT,
            extra: `customize`,
        }),
    };
}
